import { render, staticRenderFns } from "./DialogoAdicionarHora.vue?vue&type=template&id=dcc301e0&scoped=true&"
import script from "./DialogoAdicionarHora.vue?vue&type=script&lang=js&"
export * from "./DialogoAdicionarHora.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc301e0",
  null
  
)

export default component.exports